module.exports = __webpack_public_path__ + "img/sunlitcavern.f4ede063.png";